import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectBuyPackageModalGifts } from '../../../../../../../../selectors/buyPackageModal';
import * as styles from './Gifts.css';
import { ServiceRow } from '../ServiceRow';
import { UIHeading5 } from '@cian/ui-kit';
import presentIcon from '../../../../../../../../assets/present.svg';

export const GiftsContainer = () => {
  const gifts = useSelector(selectBuyPackageModalGifts);

  if (!Array.isArray(gifts) || gifts.length === 0) {
    return null;
  }

  return (
    <div className={styles['wrapper']}>
      <div className={styles['title']}>
        <img src={presentIcon} width={16} height={16} className={styles['icon']} />

        <UIHeading5>В подарок</UIHeading5>
      </div>

      {gifts.map((gift, key) => {
        return (
          <ServiceRow
            key={key}
            name={gift.name}
            count={gift.count}
            durationInDays={gift.durationInDays}
            price={gift.price}
            marketingPrice={gift.marketingPrice}
          />
        );
      })}
    </div>
  );
};
